import React from 'react';
import { Layer, Source } from 'react-map-gl';

import { IMapFeatureSources } from '../../interfaces';

/**
 * Sourced Layers generated from map feature sources
 */
const Fibers: React.FC<IMapFeatureSources> = ({ sources = [], hiddenSources = [] }): JSX.Element | null => {
	const renderFibers = (): Array<JSX.Element> =>(sources.map((source, idx)=>{
		const { data } = source;
		const {
			layer_type: layerType,
			layout,
			paint,
			source_layer: sourceLayer
		} = data;

		return (
			<Layer
				source-layer={ sourceLayer }
				key={ `layer_${idx}` }
				type={ layerType as unknown as any }
				id={ `layer_${ sourceLayer }` }
				layout={ {
					...layout,
					visibility: hiddenSources.includes(source) ? 'none' : 'visible'
				} }
				paint={ paint } />
		);
	}));

	if (sources.length < 1) {
		return null;
	}

	const { data } = sources[ 0 ];
	const { options } = data;
	const { url } = options;

	return (
		<Source type='vector' url={ url }>
			{ renderFibers() }
		</Source>
	);
};

export default Fibers;
